var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1914 0.176842L19.8164 5.59207C19.9375 5.70865 20 5.86283 20 5.98317C20 6.10351 19.939 6.29109 19.8169 6.40849L14.1919 11.8237C13.9477 12.0588 13.552 12.0588 13.3083 11.8237C13.0645 11.5887 13.0641 11.2077 13.3083 10.9731L17.8669 6.58449H0.625C0.279531 6.58449 0 6.31538 0 6.01664C0 5.68406 0.279531 5.41495 0.625 5.41495H17.8672L13.3086 1.02636C13.0645 0.79132 13.0645 0.410373 13.3086 0.175713C13.5527 -0.0589466 13.9492 -0.0585706 14.1914 0.176842Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/arrow-long.88da275a9ca4e30887d8d5909094acd0.svg";
export { ForwardRef as ReactComponent };